import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_anhanger-gear/artifacts/lhj2tq1t_Black%20Logo.png";

const navigation = [
  { name: "Startseite", href: "/" },
  { name: "Anhänger mieten", href: "/anhaenger" },
  { name: "Kontakt", href: "/kontakt" },
];

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (href) => location.pathname === href;

  return (
    <header className="sticky top-0 z-50 w-full bg-white/95 backdrop-blur-md border-b border-zinc-200">
      <nav className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex h-20 items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center" data-testid="header-logo">
            <img 
              src={LOGO_URL} 
              alt="Rent Mich AT" 
              className="h-16 sm:h-20 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                data-testid={`nav-${item.href.replace("/", "") || "home"}`}
                className={`text-sm font-medium transition-colors ${
                  isActive(item.href)
                    ? "text-orange-600"
                    : "text-zinc-600 hover:text-zinc-900"
                }`}
              >
                {item.name}
              </Link>
            ))}
          </div>

          {/* Desktop CTA */}
          <div className="hidden md:flex items-center gap-4">
            <Link to="/anhaenger">
              <Button 
                data-testid="header-cta-btn"
                className="bg-orange-600 hover:bg-orange-700 text-white px-6"
              >
                Jetzt Verfügbarkeit prüfen
              </Button>
            </Link>
          </div>

          {/* Mobile Menu */}
          <Sheet open={mobileMenuOpen} onOpenChange={setMobileMenuOpen}>
            <SheetTrigger asChild className="md:hidden">
              <Button variant="ghost" size="icon" data-testid="mobile-menu-btn">
                <Menu className="h-6 w-6" />
                <span className="sr-only">Menü öffnen</span>
              </Button>
            </SheetTrigger>
            <SheetContent side="right" className="w-[280px] bg-white">
              <div className="flex flex-col gap-6 mt-8">
                {navigation.map((item) => (
                  <Link
                    key={item.name}
                    to={item.href}
                    onClick={() => setMobileMenuOpen(false)}
                    className={`text-lg font-medium transition-colors ${
                      isActive(item.href)
                        ? "text-orange-600"
                        : "text-zinc-600 hover:text-zinc-900"
                    }`}
                  >
                    {item.name}
                  </Link>
                ))}
                <Link to="/anhaenger" onClick={() => setMobileMenuOpen(false)}>
                  <Button className="w-full bg-orange-600 hover:bg-orange-700 text-white mt-4">
                    Jetzt Verfügbarkeit prüfen
                  </Button>
                </Link>
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </nav>
    </header>
  );
}
